document.addEventListener('DOMContentLoaded', function () {
	if (window.innerWidth > 768) {
		var cursor = document.querySelector('.cursor');
		var follower = document.querySelector('.cursor-follower');

		var posX = 0,
			posY = 0,
			mouseX = 0,
			mouseY = 0,
			scrollX = 0,
			scrollY = 0;

		function animate() {
			posX += (mouseX - posX) / 9;
			posY += (mouseY - posY) / 9;

			follower.style.left = posX + scrollX - 24 + 'px';
			follower.style.top = posY + scrollY - 24 + 'px';

			cursor.style.left = mouseX + scrollX - 4 + 'px';
			cursor.style.top = mouseY + scrollY - 4 + 'px';

			requestAnimationFrame(animate);
		}
		animate();

		document.addEventListener('mousemove', function (e) {
			mouseX = e.pageX - scrollX;
			mouseY = e.pageY - scrollY;
		});

		// Track last known client (viewport) mouse coordinates
		var clientX = 0, clientY = 0;
		document.addEventListener('mousemove', function (e) {
			clientX = e.clientX;
			clientY = e.clientY;
		});

		// Update scroll position & check hover state
		function onScroll() {
			scrollX = window.scrollX;
			scrollY = window.scrollY;

			// Check if cursor is still over a grid card during scroll
			var el = document.elementFromPoint(clientX, clientY);
			var card = el && el.closest('.mm-projets-grid-card');
			if (!card && isOverGridCard) {
				isOverGridCard = false;
				hideGridCTA();
			} else if (card && !isOverGridCard) {
				isOverGridCard = true;
				showGridCTA();
			}

			// Check offres rows during scroll
			var row = el && el.closest('.mm-offres-row');
			var rowHasCta = row && row.hasAttribute('data-cursor-text') && row.hasAttribute('data-cursor-link');
			if ((!row || !rowHasCta) && isOverOffreRow) {
				isOverOffreRow = false;
				hideOffresCTA();
			} else if (rowHasCta && !isOverOffreRow) {
				isOverOffreRow = true;
				showOffresCTA(row);
			}
		}

		window.addEventListener('scroll', onScroll);


		var projects = document.querySelectorAll('.mm-projets-project');
		projects.forEach(function (project) {
			project.addEventListener('mouseenter', function () {
				cursor.classList.add('active');
				follower.classList.add('active');
			});

			project.addEventListener('mouseleave', function () {
				cursor.classList.remove('active');
				follower.classList.remove('active');
			});
		});

		// New masonry grid project cards — CTA follows on the follower element
		var gridHideTimeout = null;
		var isOverGridCard = false;

		function showGridCTA() {
			if (gridHideTimeout) { clearTimeout(gridHideTimeout); gridHideTimeout = null; }
			follower.classList.remove('active-grid-out');
			cursor.classList.add('active-grid-hidden');
			follower.classList.add('active-grid');
		}
		function hideGridCTA() {
			if (gridHideTimeout) return;
			cursor.classList.remove('active-grid-hidden');
			follower.classList.add('active-grid-out');
			gridHideTimeout = setTimeout(function () {
				follower.classList.remove('active-grid', 'active-grid-out');
				gridHideTimeout = null;
			}, 200);
		}

		// Use mousemove detection instead of mouseenter/mouseleave for reliability
		document.addEventListener('mousemove', function (e) {
			var el = document.elementFromPoint(e.clientX, e.clientY);
			var card = el && el.closest('.mm-projets-grid-card');
			if (card && !isOverGridCard) {
				isOverGridCard = true;
				showGridCTA();
			} else if (!card && isOverGridCard) {
				isOverGridCard = false;
				hideGridCTA();
			}
		});

		// Offres rows — CTA follows cursor with dynamic text
		var offresHideTimeout = null;
		var isOverOffreRow = false;

		function showOffresCTA(row) {
			if (offresHideTimeout) { clearTimeout(offresHideTimeout); offresHideTimeout = null; }
			var text = row.getAttribute('data-cursor-text') || 'Découvrir';
			follower.setAttribute('data-cta-text', text);
			follower.classList.remove('active-offres-out');
			cursor.classList.add('active-grid-hidden');
			follower.classList.add('active-offres');
		}
		function hideOffresCTA() {
			if (offresHideTimeout) return;
			cursor.classList.remove('active-grid-hidden');
			follower.classList.add('active-offres-out');
			offresHideTimeout = setTimeout(function () {
				follower.classList.remove('active-offres', 'active-offres-out');
				follower.removeAttribute('data-cta-text');
				offresHideTimeout = null;
			}, 200);
		}

		// Use mousemove detection for offres rows too
		document.addEventListener('mousemove', function (e) {
			var el = document.elementFromPoint(e.clientX, e.clientY);
			var row = el && el.closest('.mm-offres-row');
			// Only show CTA if the row has cursor_cta text and link configured
			var hasCtaConfig = row && row.hasAttribute('data-cursor-text') && row.hasAttribute('data-cursor-link');
			if (hasCtaConfig && !isOverOffreRow) {
				isOverOffreRow = true;
				showOffresCTA(row);
			} else if (hasCtaConfig && isOverOffreRow) {
				// Update text if hovering a different row
				var text = row.getAttribute('data-cursor-text');
				if (follower.getAttribute('data-cta-text') !== text) {
					showOffresCTA(row);
				}
			} else if ((!row || !hasCtaConfig) && isOverOffreRow) {
				isOverOffreRow = false;
				hideOffresCTA();
			}
		});

		// Click handler for offres rows
		document.addEventListener('click', function (e) {
			var row = e.target.closest('.mm-offres-row');
			if (row) {
				var link = row.getAttribute('data-cursor-link');
				if (link) window.location.href = link;
			}
		});

		var blackSections = document.querySelectorAll('.mm-wrapper-black, .mm-projets-grid-section, .mm-section-offres');
		blackSections.forEach(function (blackSection) {
			blackSection.addEventListener('mouseover', function () {
				cursor.classList.add('primary');
				follower.classList.add('primary');
			});

			blackSection.addEventListener('mouseleave', function () {
				cursor.classList.remove('primary');
				follower.classList.remove('primary');
			});
		});

		var CTAs = document.querySelectorAll('.mm-btn-primary');
		CTAs.forEach(function (CTA) {
			CTA.addEventListener('mouseover', function () {
				cursor.classList.add('interact');
				follower.classList.add('interact');
			});

			CTA.addEventListener('mouseleave', function () {
				cursor.classList.remove('interact');
				follower.classList.remove('interact');
			});
		});

		var contactForm = document.querySelector('.mm-contact-iframe');
		if (contactForm) {
			contactForm.addEventListener('mouseover', function () {
				cursor.style.display = 'none';
				follower.style.display = 'none';
			});

			contactForm.addEventListener('mouseleave', function () {
				cursor.style.display = 'block';
				follower.style.display = 'block';
			});
		}

	}
});
